import React, { useMemo } from 'react'

import Image from 'shared/components/common/Image'

import { t, Trans } from 'src/translations'

const Footer = () => {
  const year = useMemo(() => new Date().getFullYear(), [])

  return (
    <div className='toastLocalFooter'>
      <div className='container paddedSection'>
        <div className='footerContent'>
          <div className='contentCell pure-g'>
            <div className='footerNav pure-u-12-24 pure-u-sm-6-24'>
              <div>{t('footer.toast-inc', { year })}</div>
              <Image
                src='/icons/toast-logo-filled.svg'
                alt='Toast'
                height={45}
                className='toastBadge'
              />
            </div>

            <ul className='footerNav navDown pure-u-12-24 pure-u-sm-6-24'>
              <li>
                <a href='https://pos.toasttab.com/about'>
                  {t('footer.about-toast')}
                </a>
              </li>
              <li>
                <a href='https://pos.toasttab.com/'>
                  {t('footer.for-restaurants')}
                </a>
              </li>
            </ul>

            <ul className='footerNav navDown pure-u-12-24 pure-u-sm-6-24'>
              <li>
                <a
                  href='https://pos.toasttab.com/terms-of-service'
                  rel='nofollow'
                >
                  {t('footer.terms-of-service')}
                </a>
              </li>
              <li>
                <a href='https://pos.toasttab.com/privacy' rel='nofollow'>
                  {t('footer.privacy-statement')}
                </a>
              </li>
              <li>
                <a
                  href='https://pos.toasttab.com/privacy#addendum'
                  rel='nofollow'
                >
                  <Trans
                    i18nKey='footer.do-not-sell-my-personal-information'
                    components={{ br: <br /> }}
                  />
                </a>
              </li>
            </ul>

            <div className='footerNav navDown pure-u-12-24 pure-u-sm-6-24'>
              <Trans
                i18nKey='footer.made-with-love-in-boston'
                components={{
                  Image: (
                    <Image
                      src='/icons/heart-orange.svg'
                      alt={t('footer.alt.love')}
                      height={11}
                      className='heart-icon'
                    />
                  )
                }}
              />
              <ul className='footerNav socialMedia'>
                <li>
                  <a
                    href='https://instagram.com/toasttab'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <Image
                      src='icons/instagram-gray.svg'
                      alt={t('footer.alt.instagram')}
                      className='instagram'
                      height={12}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href='https://twitter.com/toasttab'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <Image
                      src='icons/twitter-gray.svg'
                      alt={t('footer.alt.twitter')}
                      className='twitter'
                      height={12}
                    />
                  </a>
                </li>
                <li>
                  <a
                    href='https://www.facebook.com/toasttab/'
                    target='_blank'
                    rel='noreferrer'
                  >
                    <Image
                      src='icons/facebook-gray.svg'
                      alt={t('footer.alt.facebook')}
                      className='facebook'
                      height={12}
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Footer
